import { Component, input, signal, ViewChild } from '@angular/core';
import { UserModel } from '../../../../core/models/data/user.model';
import { ModalActions, ModalTypes } from '../../../../core/enums/base.enums';
import { BootstrapService } from '../../../../core/services/bootstrap.service';
import { InfoModalComponent } from "../../../../parts/info-modal/info-modal.component";
import { ConfirmationModalComponent } from "../../../../parts/confirmation-modal/confirmation-modal.component";
import { UserService } from '../../../../core/services/user.service';
import { UserSessionService } from '../../../../core/services/user-session.service';
import { UsersMessagingConstants } from '../../../../core/constants/messaging.constants';

@Component({
  selector: 'ms-user-security',
  imports: [InfoModalComponent, ConfirmationModalComponent],
  templateUrl: './user-security.component.html'
})
export class UserSecurityComponent {

  public user = input<UserModel | undefined>();
  public isSubmitting = signal<boolean | undefined>(undefined);

  @ViewChild('userSecurityConfirmationModalRef') confirmationModalRef!: ConfirmationModalComponent;
  @ViewChild('userSecurityInfoModalRef') infoModalRef!: InfoModalComponent;
  
  constructor(
    private bootstrapService: BootstrapService,
    private userService: UserService,
    private userSessionService: UserSessionService) {}

  public openResetPasswordModal(): void {
    this.confirmationModalRef.modalType.set(ModalTypes.Question);
    if (this.userSessionService.activeUser()?.userId === this.user()?.userId) {
      this.confirmationModalRef.message.set(UsersMessagingConstants.USERS_RESET_OWN_PASSWORD_CONFIRMATION());
    } else {
      const confirmationMessageData = {firstName: this.user()?.firstName, lastName: this.user()?.lastName};
      const confirmationMessage = UsersMessagingConstants.USERS_RESET_OTHERS_PASSWORD_CONFIRMATION().replaceValuesWithObject(confirmationMessageData);
      this.confirmationModalRef.message.set(confirmationMessage);
    }
    this.bootstrapService.manageModal("#userSecurityConfirmationModal", ModalActions.Show);
  }

  public onConfirmationModalConfirmed(): void {
    if (this.user()?.userId) {      
      this.sendUserPasswordReset();
    } else {
      this.infoModalRef.modalType.set(ModalTypes.Failure);
      this.infoModalRef.message.set(UsersMessagingConstants.USERS_ERROR_NO_ACTIVE_USER());
      this.bootstrapService.manageModal("#userSecurityInfoModal", ModalActions.Show);
    }
  }
  
  public onConfirmationModalCanceled(): void {
    this.bootstrapService.manageModal("#userSecurityConfirmationModal", ModalActions.Hide);
  }
  
  public async sendUserPasswordReset(): Promise<void> {
    this.isSubmitting.set(true);
    const response = await this.userService.sendUserPasswordReset(this.user()!);    
    
    if (response.success === true && response.data === undefined) {
      this.infoModalRef.modalType.set(ModalTypes.Success);

      const confirmationMessageData = {firstName: this.user()?.firstName, lastName: this.user()?.lastName};
      const confirmationMessage = UsersMessagingConstants.USERS_PASSWORD_RESET_SUCCESSFUL().replaceValuesWithObject(confirmationMessageData);

      this.infoModalRef.message.set(confirmationMessage);
    } else if (response.success === false) {
      this.infoModalRef.modalType.set(ModalTypes.Failure);
      this.infoModalRef.message.set(response.message);
    }

    this.bootstrapService.manageModal("#userSecurityConfirmationModal", ModalActions.Hide);

    if ((response.success === true && response.data === undefined) || response.success === false) {
      this.bootstrapService.manageModal("#userSecurityInfoModal", ModalActions.Show);    
    } else if (response.success === true && response.data !== undefined && response.data.resetLink) {
      this.redirectToResetLink(response.data.resetLink);
    }

    setTimeout(()=> { this.isSubmitting.set(false); }, 1000);
  }

  public redirectToResetLink(url: string): void {
    window.location.href = url;
  }

  public onInfoModalConfirmed(): void {
    this.bootstrapService.manageModal("#userSecurityInfoModal", ModalActions.Hide);
  }
}
